/**
 * @namespace TcmsEventTracking
 * @version 1.2.0
 *
 * A overview where EventTracking is used
 * https://confluence.check24.de/pages/viewpage.action?pageId=240616669
 */

/**
 * Validate given tracking arguments
 *
 * @param {object} trackingData
 */
let isTrackingDataValid = (trackingData) => {
    if (!trackingData) {
        return false;
    }

    let neededArguments = [
        'dataLayerName', 'category', 'action'
    ];
    let foundArguments = [];

    neededArguments.map(function(argument) {
        if (trackingData.hasOwnProperty(argument) && trackingData[argument]) {
            foundArguments.push(argument);
        }
    });

    return neededArguments.length === foundArguments.length;
};

/**
 * Add eventlistener to node
 *
 * @param {Node}   node
 * @param {Object} trackingData
 */
const addListenerToNode = (node, trackingData) => {
    if (isTrackingDataValid(trackingData) === true) {
        node.addEventListener(trackingData.eventListener, function(event) {
            let trackingMethod = trackingData.hasOwnProperty('trackingMethod') ? trackingData.trackingMethod : null;

            trackEvent(trackingData, trackingMethod);
        });
        node.dataset.eventTrackingAdded = true;
    } else {
        console.error(new Error('Tracking Data is not valid'));
    }
};

/**
 * Check first key is type of object
 *
 * @param {Object} trackingDataObj
 *
 * @returns {boolean}
 */
const isTrackingDataFirstKeyObject = (trackingDataObj) => {
    if (trackingDataObj == null) {
        return false;
    }

    let [first] = Object.values(trackingDataObj);

    return typeof first === 'object';
};

/**
 * Push events to analytics
 * two possible methods can be used 1. the old _gaq or the tagManager datalayer
 *
 * @param {object} data
 * @param {string} trackingMethod
 */
let trackEvent = (data, trackingMethod) => {
    if (!isTrackingDataValid(data)) {
        console.warn('event tracking data are invalid!');
        return;
    }

    trackingMethod = trackingMethod || '';
    let trackingData = {
        eventCategory: data.category || '',
        eventAction: data.action || '',
        eventLabel: data.label || ''
    };

    if (trackingMethod === '_gaq' && window._gaq) {
        if (window._gaq) {
            window._gaq.push([
                '_trackEvent',
                trackingData.eventCategory,
                trackingData.eventAction,
                trackingData.eventLabel
            ]);
        }
    } else if (trackingMethod === '_paq' && window._paq) {
        if (window._paq) {
            trackingData.event = data.dataLayerName;
            window._paq.push([
                trackingData.event,
                trackingData.eventCategory,
                trackingData.eventAction,
                trackingData.eventLabel
            ]);
        }
    } else {
        trackingData.event = data.dataLayerName;

        if (window.dataLayer) {
            window.dataLayer.push(trackingData);
        }
    }
};

/**
 * Add tracking EventListener to an node
 *
 * @param {Node} node
 * @param {Object} trackingDataObj
 *
 * {
 *   eventListener: 'click',
 *   dataLayerName: '',
 *   category: '',
 *   action : '',
 *   label: '',
 *   trackingMethod: '' // optional
 * }
 *
 */
let addListener = (node, trackingDataObj = null) => {
    if (!node) {
        return;
    }

    let trackingData = trackingDataObj || node;

    if (!trackingData) {
        return;
    }

    if (trackingData instanceof HTMLElement) {
        try {
            trackingData = JSON.parse(trackingData.dataset.eventtracking);
        } catch (e) {
            console.error(new Error(e.message + ': ' + trackingData.dataset.eventtracking));
        }
    }

    if (isTrackingDataFirstKeyObject(trackingData)) {
        Object.values(trackingData).forEach((val) => addListenerToNode(node, val));
    } else {
        addListenerToNode(node, trackingData);
    }
};

/**
 * Collect all datasets by type of eventTracking and
 * addEventListener also specify the tracking method
 */
let addListeners = () => {
    let trackingData = document.querySelectorAll('[data-eventtracking]');

    [].forEach.call(trackingData, function(node) {
        if (!node.dataset.hasOwnProperty('eventTrackingAdded')) {
            addListener(node);
        }
    });
};

try {
    let trackingManager = window.TCMS.trackingManager;

    trackingManager.eventTracking = null;

    if (
        trackingManager &&
        trackingManager.hasOwnProperty('trackingEnabled') &&
        trackingManager.trackingEnabled === true
    ) {
        trackingManager.eventTracking = {
            addListener: addListener,
            addListeners: addListeners,
            trackEvent: trackEvent
        };
    }
} catch (err) {
    console.error(err);
}
